/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamSignal = {
    properties: {
        teamAuditLogId: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'uuid4',
            }, {
                type: 'null',
            }],
        },
        userText: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        clavaNote: {
            type: 'string',
            isRequired: true,
        },
        resolved: {
            type: 'boolean',
            isRequired: true,
        },
        timestamp: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        user: {
            type: 'UserSmall',
            isRequired: true,
        },
        signalType: {
            type: 'SignalTypeEnum',
            isRequired: true,
        },
        team: {
            type: 'TeamSmall',
            isRequired: true,
        },
    },
} as const;
